const gridImages = [
  {
    title: "Road Bikes",
    categoryOne: "Performance & Racing",
    categoryOneLink: "/collections/performance-racing",
    categoryTwo: "Triathlon",
    categoryTwoLink: "/collections/triathlon-time-trial",
    viewAll: "View All",
    viewAllLink: "/collections/road-bikes",
    desktopImage:
      "https://cdn.shopify.com/s/files/1/0718/1094/1242/files/RoadBikes-Desktop.jpg?v=1676539506",
    mobileImage:
      "https://cdn.shopify.com/s/files/1/0718/1094/1242/files/RoadBikes-MB.jpg?v=1676540444",
    imageAlt: "",
    imageLink: "/collections/road-bikes",
  },
  {
    title: "Mountain Bikes",
    categoryOne: "Full Suspension",
    categoryOneLink: "/collections/full-suspension",
    categoryTwo: "Hardtail",
    categoryTwoLink: "/collections/hardtail",
    viewAll: "View All",
    viewAllLink: "/collections/mountain-bikes",
    desktopImage:
      "https://cdn.shopify.com/s/files/1/0718/1094/1242/files/MountainBikes-Desktop_bf4319cf-0207-4a70-afb1-b9b98591b267.png?v=1710262982",
    mobileImage:
      "https://cdn.shopify.com/s/files/1/0718/1094/1242/files/MountainBikes-MB_461e34ff-cd5a-406b-bce4-a3c465fd2ef0.png?v=1710262980",
    imageAlt: "",
    imageLink: "/collections/mountain-bikes",
  },
  {
    title: "Electric Bikes",
    categoryOne: "E-Mountain",
    categoryOneLink: "/collections/electric-mountain-bikes",
    // categoryTwo:'Triathlon',
    // categoryTwoLink:'/collections/triathlon-time-trial',
    viewAll: "View All",
    viewAllLink: "/collections/electric-mountain-bikes",
    desktopImage:
      "https://cdn.shopify.com/s/files/1/0718/1094/1242/files/Ebikes-desktop.jpg?v=1676539506",
    mobileImage:
      "https://cdn.shopify.com/s/files/1/0718/1094/1242/files/Ebikes-MB.jpg?v=16765404441",
    imageAlt: "",
    imageLink: "/collections/electric-mountain-bikes",
  },
  {
    title: "Gravel Bikes",
    categoryOne: "Gravel",
    categoryOneLink: "/collections/cross-gravel-bikes",
    // categoryTwo:'Triathlon',
    // categoryTwoLink:'/collections/triathlon-time-trial',
    viewAll: "View All",
    viewAllLink: "/collections/cross-gravel-bikes",
    desktopImage:
      "https://cdn.shopify.com/s/files/1/0718/1094/1242/files/GravelBikes-Desktop.jpg?v=1676539506",
    mobileImage:
      "https://cdn.shopify.com/s/files/1/0718/1094/1242/files/GravelBikes-MB.jpg?v=1676540444",
    imageAlt: "",
    imageLink: "/collections/cross-gravel-bikes",
  },
];

export { gridImages };
